<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_98_10386)"><path d="M23.78 12.53l-2.25 2.25a.75.75 0 01-1.06 0l-2.25-2.25a.75.75 0 111.06-1.061l.97.97V12A8.25 8.25 0 005.296 7.187a.75.75 0 11-1.219-.875 9.75 9.75 0 0117.673 5.687v.44l.97-.97a.75.75 0 111.06 1.061zm-3.86 5.156A9.75 9.75 0 012.25 12v-.44l-.97.971a.75.75 0 01-1.06-1.061l2.25-2.25a.75.75 0 011.06 0l2.25 2.25a.75.75 0 11-1.06 1.061l-.97-.97V12a8.214 8.214 0 002.085 5.475 7.469 7.469 0 013.38-2.695 4.5 4.5 0 115.57 0 7.462 7.462 0 013.382 2.698 8.4 8.4 0 00.535-.666.75.75 0 011.219.875h-.001zM12 14.25a3 3 0 100-6 3 3 0 000 6zm0 6a8.27 8.27 0 005.055-1.733 6 6 0 00-10.11 0A8.21 8.21 0 0012 20.249z"/></g><defs><clipPath id="clip0_98_10386"><path d="M0 0h24v24H0z"/></clipPath></defs></svg>

</template>


<script>

  export default {"name":"icon-349499527f645e9867445e3676ec2b43"}

</script>